import type { Shape, Theme, Video, Img } from '../../types/props.js'
import type { BrandEquityProps } from '../BrandEquity/types.js'
import type { MemberEquityProps } from '../MemberEquity/types.js'

export type MediaPlayerComponent = BrandEquityProps | MemberEquityProps

export interface MediaPlayerBaseProps extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    shape?: Shape
    theme?: Theme
    title?: string
    videoTitle?: string
    btnText?: string
    img?: Img
    mobImg?: Img
    video?: Video
    mobVideo?: Video
    isYouTube?: boolean
    youtubePcId: string
    youtubeMobileId?: string
    components?: MediaPlayerComponent[]
  }
  wrapperClassName?: string
}
